import React from 'react'
import { Outlet } from 'react-router-dom'
import Header from './header/header';
import Footer from './footer/footer';

function layout() {
  return (
    <div className="">
      <Header />
        <Outlet />
      <Footer />
    </div>
  )
}

export default layout